import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {DocumentTemplateDataService} from './impl/service/ngrx/documentTemplateData.service';
import {DocumentTemplateRepository} from './impl/service/ngrx/documentTemplate.repository';
import {errorMessages} from "../../core/error/errorMessages";

@NgModule()
export class DocumentTemplateModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: DocumentTemplateDataService,
                repository: DocumentTemplateRepository) {
        entityDataService.registerServices({
            DocumentTemplate: dataService,
        });
        entityServices.registerEntityCollectionServices({
            DocumentTemplate: repository,
        });
        errorMessages.set('DOCUMENT_TEMPLATE_SAVE_EXTERNAL_SIGNATURE_PLACEHOLDER_MISSING', 'Aucune signature externe déctectée dans le document');
        errorMessages.set('DOCUMENT_TEMPLATE_SAVE_EXTERNAL_SIGNATURE_PLACEHOLDER_BUT_NOT_ACTIVATED', 'Une signature externe a été détectée dans le document mais la case n\'a pas été cochée');
    }
}
